import * as RadixPopover from '@radix-ui/react-popover';
import './Popover.css';

export const Popover = ({
  trigger,
  children,
  collisionPadding,
}: {
  trigger: React.ReactNode;
  children: React.ReactNode;
  collisionPadding?: number;
}) => (
  <RadixPopover.Root>
    <RadixPopover.Trigger asChild>
      <button>{trigger}</button>
    </RadixPopover.Trigger>
    <RadixPopover.Portal>
      <RadixPopover.Content
        className="PopoverContent"
        collisionPadding={collisionPadding}
      >
        {children}
        <RadixPopover.Arrow className="PopoverArrow" />
      </RadixPopover.Content>
    </RadixPopover.Portal>
  </RadixPopover.Root>
);
